import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export default {
  setUserInfo: data => axios.put(`${BASE_URL}${data.callback_id}`, data.body),
  getUserInfo: data => axios.get(`${BASE_URL}${data.callback_id}`),
};
